'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  theme: _propTypes2.default.object.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/react-css-themr/lib/utils/themr-shape.js
// module id = 5927
// module chunks = 39